import React, { useState, useEffect } from 'react'
import { MoonIcon, SunIcon } from '../icons'

// localStorage can throw (e.g. private mode in some browsers): fall back to no saved theme
const readSavedTheme = () => {
    try {
        return localStorage.getItem('theme');
    } catch {
        return null;
    }
}

const saveTheme = (theme) => {
    try {
        localStorage.setItem('theme', theme);
    } catch {
        // The theme just won't persist across visits
    }
}

export const ThemeToggle = () => {
    const [darkMode, setDarkMode] = useState(false)

    // Al caricamento iniziale, controlla se la modalità dark è già attiva
    // (ad esempio memorizzata nel localStorage o nelle preferenze del sistema)
    useEffect(() => {
        const root = window.document.documentElement;
        const initialTheme = readSavedTheme();

        if (initialTheme === 'dark' || (!initialTheme && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
            root.classList.add('dark');
            setDarkMode(true);
        }
    }, []);

    // Funzione per gestire il cambio di tema
    const toggleTheme = () => {
        const root = window.document.documentElement;
    
        if (darkMode) root.classList.remove('dark');
        else root.classList.add('dark');
    
        saveTheme(darkMode ? 'light' : 'dark');
        setDarkMode(!darkMode);
    };

    // Shows the theme you'd switch to
    const Icon = darkMode ? SunIcon : MoonIcon

    return (
        <button onClick={toggleTheme} className="flex justify-center items-center dark:text-stone-800 bg-stone-800 dark:bg-stone-200 p-1 sm:p-2 aspect-square rounded-full">
            <Icon className="fill-current size-3 sm:size-6" />
        </button>
    )
}
